import { createComponentInstance } from '@/utils/mount-component'
import { inBrowser } from '@/utils'
import DiamondRecharge from './DiamondRecharge.vue'

let instance

/**
 * Show diamond recharge popup
 * @param {Object} options - Popup options
 * @param {string} options.action - Action identifier for API request
 * @param {string} options.from - Enter source for analytics tracking
 * @param {Function} options.onPurchase - Callback when purchase completes (deprecated, use promise instead)
 * @param {Function} options.onClose - Callback when popup closes (deprecated, use promise instead)
 * @returns {Promise<{ action: 'purchase' | 'close', data?: { product, payment } }>} Resolves with action and data
 */
export function showDiamondRecharge(options = {}) {
  if (!inBrowser) {
    return Promise.resolve(undefined)
  }

  return new Promise((resolve) => {
    if (!instance) {
      instance = createComponentInstance(DiamondRecharge)
    }

    const { action, from, onPurchase, onClose } = options

    // Store callbacks for later use
    const callbacks = {
      onPurchase: (data) => {
        if (onPurchase) {
          onPurchase(data)
        }
        // Resolve promise
        resolve({ action: 'purchase', data })
      },
      onClose: () => {
        if (onClose) {
          onClose()
        }
        // Resolve promise
        resolve({ action: 'close' })
      },
    }

    instance.open({
      action,
      from,
      ...callbacks,
    })
  })
}

/**
 * Close the currently displayed diamond recharge popup
 */
export function closeDiamondRecharge() {
  if (instance) {
    instance.toggle(false)
  }
}
